module.exports = __webpack_public_path__ + "img/0.15d9ed2f.png";